import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { designSystem } from '@yola/ws-ui';
import PropTypes from 'prop-types';
import TemplateThumb from '../template-thumb';
import { PREVIEW_COLUMNS_COUNT } from '../../constants/common';

const { Container } = designSystem;

const defaultTemplates = [];

const GalleryGrid = forwardRef(
  (
    {
      templates = defaultTemplates,
      isLoading,
      isAISiteWizardEnabled = false,
      onTemplatePreviewClick = Function.prototype,
      onTemplateEditClick = Function.prototype,
      gridColumns = PREVIEW_COLUMNS_COUNT.twoColumns,
    },
    ref
  ) => {
    const classes = classNames('gallery-grid', {
      'gallery-grid--3-col': gridColumns === PREVIEW_COLUMNS_COUNT.threeColumns,
    });

    return (
      <Container>
        <div ref={ref}>
          <div className={classes}>
            {templates.map(({ slug, previewUrl, name }) => (
              <TemplateThumb
                isLoading={isLoading}
                isAISiteWizardEnabled={isAISiteWizardEnabled}
                key={slug}
                name={name}
                previewUrl={previewUrl}
                templateSlug={slug}
                onTemplatePreviewClick={onTemplatePreviewClick}
                onTemplateEditClick={onTemplateEditClick}
                layout3Cols={gridColumns === PREVIEW_COLUMNS_COUNT.threeColumns}
              />
            ))}
          </div>
        </div>
      </Container>
    );
  }
);

GalleryGrid.displayName = 'GalleryGrid';

GalleryGrid.propTypes = {
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      previewUrl: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool.isRequired,
  gridColumns: PropTypes.oneOf(Object.values(PREVIEW_COLUMNS_COUNT)),
  onTemplatePreviewClick: PropTypes.func,
  onTemplateEditClick: PropTypes.func,
  isAISiteWizardEnabled: PropTypes.bool,
};

export default GalleryGrid;
